
import InfoCircle from '@/assets/icons/fontawesome/duotone/info-circle.svg?inline'

export default {
  components: {
    InfoCircle,
  },
  props: {
    cancellation: {
      type: Object,
      required: true,
    },
  },
  methods: {
    buttonClicked() {
      this.$emit('button-clicked')
    },
  },
}
